import { cva } from "class-variance-authority";
import clsx from "clsx";
import type { ComponentPropsWithRef } from "react";
import { type GapToken, gapToClass } from "./gap";

interface StackProps extends ComponentPropsWithRef<"div"> {
  gap?: GapToken;
  align?: "start" | "center" | "end" | "stretch";
  inline?: boolean;
}

const stackVariants = cva("flex-col", {
  variants: {
    align: {
      start: "items-start",
      center: "items-center",
      end: "items-end",
      stretch: "items-stretch",
    },
    inline: { true: "inline-flex", false: "flex" },
  },
  defaultVariants: { inline: false },
});

export function Stack({ gap = "none", align, inline, className, ...rest }: StackProps) {
  return <div className={clsx(stackVariants({ align, inline }), gapToClass[gap], className)} {...rest} />;
}
